// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3Ozoc","messages":"Chat_messages__33GxX","dateDivider":"Chat_dateDivider__2-SbN"};